window.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll('form');

  forms.forEach((form) => {
    const formErrors = form.querySelector("#FormErrors");
    let formInputs = form.querySelectorAll("input");

    let filteredInputs = [...formInputs].filter(
      (input) => input.getAttribute("type") !== "hidden"
    );

    if (formErrors?.querySelector('.errors')){
        filteredInputs[0].focus()
        filteredInputs.forEach(input => {
            input.setAttribute('aria-describedby', 'FormErrors')
        })
    }

    filteredInputs.forEach(input => {
        input.addEventListener('change', () => {
            input.classList.remove('error')
        })
    })

    const formButton = form.querySelector("[type='submit']");

    form.addEventListener("keypress", (event) => {
        formInputs = form.querySelectorAll("input");
        filteredInputs = [...formInputs].filter(
            (input) => input.getAttribute("type") !== "hidden"
          );

      if (event.key === "Enter") {
        formValidation(filteredInputs);
      }
    });

    formButton.addEventListener("click", () => formValidation(filteredInputs));

  });
});

const formValidation = (filteredInputs) => {
    filteredInputs.forEach((input) => {
    input.setAttribute("aria-invalid", "false");
    input.classList.remove('error')

    if (input.required && (input.value === null || input.value === "")) {
      input.setAttribute("aria-invalid", "true");
      input.classList.add('error')
    }
    if (input.getAttribute("type") === "email" && !validateEmail(input.value)) {

        input.setAttribute("aria-invalid", "true");
        input.classList.add('error')
    }
    if (input.getAttribute("type") === "tel" && !validatePhone(input.value)) {
          input.setAttribute("aria-invalid", "true");
          input.classList.add('error')
        }
  });
};

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
        /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    );
};

const validatePhone = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/
      );
  };
